var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayoutZelle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#6627CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6932 6.06883V4.29545C11.6932 4.13236 11.8256 4 11.9886 4H14.0568C14.2199 4 14.3523 4.13236 14.3523 4.29545V6.06883H17.1592C17.4854 6.06883 17.7501 6.33356 17.7501 6.65974V8.13701C17.7501 8.30254 17.6819 8.45224 17.5721 8.55955L11.9888 15.5233H17.1591C17.4853 15.5233 17.75 15.788 17.75 16.1142V17.5915C17.75 17.9176 17.4853 18.1824 17.1591 18.1824H14.3523V20.2493C14.3523 20.4124 14.2199 20.5448 14.0568 20.5448H11.9886C11.8256 20.5448 11.6932 20.4124 11.6932 20.2493V18.1824H8.59091C8.26473 18.1824 8 17.9176 8 17.5915V16.1142C8 15.9707 8.05124 15.8391 8.13642 15.7367C8.14356 15.7234 8.15217 15.7106 8.16234 15.6982L13.7518 8.72792H8.88646C8.56027 8.72792 8.29555 8.46319 8.29555 8.13701V6.65974C8.29555 6.33356 8.56027 6.06883 8.88646 6.06883H11.6932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutZelle);
export default __webpack_public_path__ + "static/media/PayoutZelle.94c4390ab9cb9e5d68db22544f727629.svg";
export { ForwardRef as ReactComponent };